export default __webpack_public_path__ + "static/fintech-3fdad77ef78c2546d4313df96f7ce482.png";